import styled from "styled-components";

export const Wrapper = styled.div`
  margin-left: 15px;
  position: relative;
  z-index: 1000;
`;

export const Selectbox = styled.select``;
